// extracted by mini-css-extract-plugin
export default {"formLayout":"shapeRoutes-module-formLayout-Yj46e","error":"shapeRoutes-module-error-lbdUu"};